import axios, { type AxiosInstance } from "axios"
import config from "config"
import type { ICreateUserGroup, IUpdateUserGroup, IUserGroup } from "types/userGroupTypes"
import authService from "./authService"

class UserGroupService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public createUserGroup = async (createUserGroup: ICreateUserGroup): Promise<IUserGroup> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.post<IUserGroup>("/usergroup", createUserGroup, config)

    return data
  }

  public getUserGroup = async (): Promise<IUserGroup> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<IUserGroup>("/usergroup", config)

    return data
  }

  public getOrganizationUserGroups = async (organizationId: string): Promise<Array<IUserGroup>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<IUserGroup>>(
      `/organization/${organizationId}/usergroup`,
      config,
    )

    return data
  }

  public updateUserGroup = async (
    userGroupId: string,
    updateUserGroup: IUpdateUserGroup,
  ): Promise<IUserGroup> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.put<IUserGroup>(
      `/usergroup/${userGroupId}`,
      updateUserGroup,
      config,
    )

    return data
  }

  public deleteUserGroup = async (userGroupId: string) => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const resp = await this.http.delete(`/usergroup/${userGroupId}`, config)

    return resp
  }
}

const userGroupService = new UserGroupService()

export default userGroupService
